import { BaseClass } from '../base/BaseClass';

import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Pagination, Autoplay]);

export class Carousel extends BaseClass {
  /**
   * Swiper options
   *
   * @type {Object}
   */
  options;

  /**
   * Swiper Object object
   *
   * @type {Object}
   */
  swiper;

  /**
   * The slider class name
   *
   * @type {string}
   */
  sliderClass;

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * Controls the carousels of the website.
   * Uses library swiperjs: https://swiperjs.com/
   *
   */
  constructor(identifier) {
    super(identifier);
    if (this.targetExists) {
      this.sliderClass = identifier;
      this.options = arguments[2];
      this.swiper = new Swiper(this.sliderClass, this.options);
    }
  }
}
